<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Add National Account
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="nationalAccountDetails">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="col-md-4">
          <mat-label>Service</mat-label>
          <mat-select formControlName="napService" matNativeControl>
            <mat-option *ngFor="let service of serviceList" [value]="service.VendorServiceTypeID">
              {{service.VendorServiceTypeName}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="col-md-4">
          <mat-form-field *ngIf="isEdit">
            <mat-label>SubService</mat-label>
            <mat-select formControlName="napSubService" matNativeControl>
              <ng-container *ngFor="let subService of subServiceList">
                <mat-option *ngIf="subService.VendorServiceToSubServiceMappingID != 56"
                  [value]="subService.VendorServiceToSubServiceMappingID">
                  {{subService.VendorSubServiceTypeName}}</mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="!isEdit">
            <mat-label>SubService</mat-label>
            <mat-select formControlName="napSubService" multiple matNativeControl required>
              <ng-container *ngFor="let subService of subServiceList">
                <mat-option *ngIf="subService.VendorServiceToSubServiceMappingID != 56"
                  [value]="subService.VendorServiceToSubServiceMappingID">
                  {{subService.VendorSubServiceTypeName}}</mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
          <div *ngIf="submitted && nationalAccountDetails.controls.napSubService.errors" class="error">
            <div *ngIf="nationalAccountDetails.controls.napSubService.errors.required">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                SubService is required.
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <mat-form-field>
            <mat-label>Account</mat-label>
            <mat-select formControlName="napParentAccounts" (selectionChange)="setParentAccountName($event)"
              matNativeControl required>
              <mat-option></mat-option>
              <mat-option *ngFor="let nationalAccount of nationalAccountProgramList"
                [value]="nationalAccount.nationalAccountKey">{{nationalAccount.nationalAccountProgram}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="submitted && nationalAccountDetails.controls.napParentAccounts.errors" class="error">
            <div *ngIf="nationalAccountDetails.controls.napParentAccounts.errors.required">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                Account is required.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="col-md-4">
          <mat-form-field>
            <mat-label>Priority</mat-label>
            <mat-select formControlName="napPriority" matNativeControl required>
              <mat-option></mat-option>
              <mat-option *ngFor="let priority of prioritys" [value]="priority"
                [disabled]="priority == data.data.nationalAccountPriority">{{priority}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="submitted && nationalAccountDetails.controls.napPriority.errors" class="error">
            <div *ngIf="nationalAccountDetails.controls.napPriority.errors.required">
              <div class="alert custom-alert-danger" role="alert">
                <span class="sr-only">Error:</span>
                Priority is required.
              </div>
            </div>
          </div>
        </div>

        <mat-form-field class="col-md-4">
          <input type="text" class="w-100" placeholder="Account Number" matInput formControlName="napAccountNumber">
        </mat-form-field>
        <mat-form-field class="col-md-4">
          <input type="text" class="w-100" placeholder="PO Mask" matInput formControlName="napPoMask">
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="addNationalAccount()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right mr-2"> Save
  </button>
  <button (click)="onNoClick()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right"> Close </button>
</mat-dialog-actions>